import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { notifyIracingLinkChanged } from "../utils/driverPrivacy";
import "../styles/IracingAuth.css";

const IracingAuthSuccess = ({ setIsLoggedIn }) => {
        const navigate = useNavigate();

        // Capture the URL params once during the very first render. React 18
        // Strict Mode double-invokes useEffect, and by the second invocation
        // we've already navigated away — so reading window.location.search
        // inside the effect would see "" and falsely fire the missing-params
        // error. useState's initializer is preserved across the strict-mode
        // double-invoke, so both effect runs see the same captured values.
        const [parsed] = useState(() => {
                const sp = new URLSearchParams(window.location.search);
                return {
                        token: sp.get("token"),
                        username: sp.get("username"),
                        isPaidUser: sp.get("isPaidUser"),
                        iracingOnly: sp.get("iracingOnly"),
                };
        });

        useEffect(() => {
                if (!parsed.token || !parsed.username) {
                        // eslint-disable-next-line no-console
                        console.error("IracingAuthSuccess missing params:", parsed);
                        navigate("/iracing-auth-error?error=missing_token&from=success", { replace: true });
                        return;
                }

                localStorage.setItem("token", parsed.token);
                localStorage.setItem("username", parsed.username);
                localStorage.setItem("isPaidUser", parsed.isPaidUser === "true" ? "true" : "false");
                localStorage.setItem("iracingLinked", "true");
                localStorage.setItem("iracingOnly", parsed.iracingOnly === "true" ? "true" : "false");
                notifyIracingLinkChanged();

                if (typeof setIsLoggedIn === "function") {
                        setIsLoggedIn(true);
                }

                navigate("/", { replace: true });
        }, [navigate, setIsLoggedIn, parsed]);

        return (
                <div className="iracing-auth-page">
                        <div className="iracing-auth-card">
                                <h2>Signing you in…</h2>
                                <p>One moment while we finish your iRacing sign-in.</p>
                        </div>
                </div>
        );
};

export default IracingAuthSuccess;
